import type { CSSObject } from "@mui/material/styles";

/**
 * Animações de entrada dos erros de campo, como FRAGMENTOS de estilo pra
 * espalhar (`...`) em `sx`/`styleOverrides`.
 *
 * Importante: o `@keyframes` vai INLINE no objeto (não via `keyframes()` do
 * emotion interpolado numa string). Em estilo-objeto, `` `${keyframes} 1s` ``
 * stringifica o keyframe ANTES do emotion ver, então a regra `@keyframes` nunca
 * é injetada e a animação não roda. Com o `@keyframes` como chave do objeto, o
 * emotion injeta a regra e o `animation-name` passa a existir. Fonte única do
 * movimento, idêntica no tema (FormHelperText) e nos erros próprios de auth.
 */

/** Mensagem de erro: fade + leve deslize de cima. */
export const fieldErrorInSx: CSSObject = {
  "@keyframes natraveFieldErrorIn": {
    from: { opacity: 0, transform: "translateY(-3px)" },
    to: { opacity: 1, transform: "none" },
  },
  animation: "natraveFieldErrorIn 200ms ease-out",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

/** Ícone de erro dentro do input: fade + leve escala. */
export const errorIconInSx: CSSObject = {
  "@keyframes natraveErrorIconIn": {
    from: { opacity: 0, transform: "scale(0.8)" },
    to: { opacity: 1, transform: "none" },
  },
  animation: "natraveErrorIconIn 200ms ease-out",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};
